module.exports = __webpack_public_path__ + "img/round-format_align_left-24px.ea9ecf38.svg";